import React from 'react';
import {Box,Stack,Link,TableRow,TableCell,Divider} from '@mui/material';
// icons 
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import {BsStar } from 'react-icons/bs';
// component
import AppHeader from '../../components/appHeader/index';
import Button from '../../components/button';
import Table from '../../components/table';
import Pagination from '../../components/pagination';
// images
import InventoryImg from '../../static/images/inventory.svg';
// constant
import { InventoryHeader } from '../../constant';

const Inventory =()=>{
  function createData(
    product,
    revenue,
    expenses,
    profit,
    margin,
    roi,
    unit
  ) {
    return {
      product,
      revenue,
      expenses,
      profit,
      margin,
      roi,
      unit
    };
  }
  const data = [];
  for (let i = 0; i <= 10; i += 1) {
    data.push(
      createData(
        <Stack direction="row" spacing={1} alignItems="center">
          <BsStar />
          <img src={InventoryImg} alt="no-product" />
          <Stack spacing={0.5} maxWidth="252px">
            <Link
              selectedItem color="#0948A7">Electric Shaver for Men Wet Dry Foil Mens Electric Razor</Link>
            <Box fontSize="12px" color="#71717A" display="flex" alignItems="center">
                        FBA:sdb8qy7r7eg
              <ContentCopyOutlinedIcon className="pointer" sx={{color:'#000',fontSize:'12px',marginLeft:'8px',marginRight:'8px'}} />
                        GR-PastalRed USA
            </Box>
          </Stack>
        </Stack>,
        <Box color="#535A6A" selectedItem>$39.85</Box>,
        <Box color="#535A6A" selectedItem>$14.28</Box>,
        <Box color="#535A6A" selectedItem>255</Box>,
        <Box color="#535A6A" selectedItem>0</Box>,
        <Box color="#535A6A" selectedItem>33</Box>,
        <Box color="#535A6A" selectedItem>200</Box>
      )
    );
  }
  return(
    <>
      <AppHeader pathname="Inventory" />
      <Box  border="1px solid #E4E4E7" mt={3} borderRadius="10px">
        <Box p={3} textAlign="right">
          <Button startIcon={<FileUploadOutlinedIcon />} text="Export Data" height="36px" />
        </Box>
        <Table tableHeader={InventoryHeader} height="320px">
          {data.map((row) => (
            <TableRow
              hover
              key={row._id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.product}
              </TableCell>
              <TableCell>{row.revenue}</TableCell>
              <TableCell>{row.expenses}</TableCell>
              <TableCell>{row.profit}</TableCell>
              <TableCell>{row.margin}</TableCell>
              <TableCell>{row.roi}</TableCell>
              <TableCell>{row.unit}</TableCell>
            </TableRow>
          ))}
        </Table>
        <Divider />
        <Box p={3}>
          <Pagination />
        </Box>
      </Box>
    </>

  );
};
export default Inventory;